<div class="flex row-collapse space-between">
  <h2>{{ 'reports.report-files.title' | translate | titlecase }}</h2>
</div>
<div class="flex row-collapse gap-5px mb-5">
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="handleDownloadMultipleReportsClick()"
    [disabled]="getSelectedCount() <= 0">
    {{ downloadReportButtonText }}
  </button>
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="handleUploadReports()"
    [hidden]="showUpload">
    {{ 'common.upload' | translate | titlecase }} {{ 'common.report' | translate | titlecase }}
  </button>
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" (click)="showUpload = false"
    [hidden]="!showUpload">
    {{ 'common.hide' | translate | titlecase }} {{ 'common.report' | translate | titlecase }} {{ 'common.upload' |
    translate | titlecase }}
  </button>
</div>
<div class="mb-5" [hidden]="!showUpload">
  <p-fileUpload name="uploadedfiles[]" [url]="fileUploadApiUrl" multiple="multiple"
    (onUpload)="handleAfterUpload()">
    <ng-template pTemplate="file" let-file>
      <div class="p-fileupload-file">
        <div class="p-fileupload-file-info">
          <span class="p-fileupload-file-name">{{ file.name }}</span>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
</div>

<p-table [showGridlines]="true" #customReportNamesReultsGrid [value]="customReportFileNames" [paginator]="false">
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'ReportName'" style="width: 100px">
        <input type="checkbox" (change)="handleSelectAll()" />
      </th>
      <th [pSortableColumn]="'ReportName'">
        {{ 'reports.report-files.report-name-column-header' | translate | titlecase }}
        <p-sortIcon field="ReportName"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'ReportName'" style="width: 100px"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>
        <input type="checkbox" [(ngModel)]="item.Selected" (change)="updateDownloadReportButtonText()" />
      </td>
      <td>
        <div>{{ item.ReportName }}</div>
      </td>
      <td>
        <button pButton type="button" class="atlas-btn atlas-btn-primary tall"
          (click)="handleDownloadClick(item.ReportName)">
          {{ 'common.download' | translate | titlecase }}
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-progressSpinner *ngIf="searching"></p-progressSpinner>
